import * as WFC from './WFConstants'
import WFObject from './WFObject'
import WFNode from './WFNode'
import WFLink from './WFLink'
import WFRepeat from './WFRepeat'

/**
 * Created by Xuz on 2020/02/15.
 * xuz@live.cn
 *
 * 实现反解SVG为JS对象
 */
const classes = {
  WFObject,
  WFNode,
  WFLink,
  WFRepeat
}

class WFDocWalker {
  constructor (workflow) {
    this.workflow = workflow
  }

  visit (rootNode) {
    let children = rootNode.children()
    for (let i = 0; i < children.length; i++) {
      this.visitNode(children[i])
    }
  }

  visitNode (nodeSvgJs) {
    let node = nodeSvgJs.node
    let type = node.nodeType
    switch (type) {
      case WFC.XML_DF_ELEMENT_NODE:
        let sClassName = node.getAttribute('wf-class')
        if (sClassName) {
          let instance = new classes[sClassName](this.workflow)
          instance.unSerial(nodeSvgJs)
        }
        this.visit(nodeSvgJs)
        break
      case WFC.XML_DF_ATTRIBUTE_NODE:
        break
      case WFC.XML_DF_TEXT_NODE:
        break
      case WFC.XML_DF_CDATA_SECTION_NODE:
        break
      case WFC.XML_DF_ENTITY_REFERENCE_NODE:
        break
      case WFC.XML_DF_ENTITY_NODE:
        break
      case WFC.XML_DF_PROCESSING_INSTRUCTION_NODE:
        break
      case WFC.XML_DF_COMMENT_NODE:
        break
      case WFC.XML_DF_DOCUMENT_NODE:
        break
      case WFC.XML_DF_DOCUMENT_TYPE_NODE:
        break
      case WFC.XML_DF_DOCUMENT_FRAGMENT_NODE:
        break
      case WFC.XML_DF_NOTATION_NODE:
        break
    }
  }
}

export default WFDocWalker
